import { gql } from '@apollo/client';

export default gql`
  mutation reassignMatch($input: ReassignMatchInput!) {
    reassignMatch(input: $input) {
      match {
        id
      }
    }
  }
`;
